
/*========================================
        Imports!!!
=========================================*/

/*--BrowserRouter--*/

import { Link, useNavigate } from 'react-router';
import { useState } from 'react';

/*--css--*/
import '../assets/css/tour.css';
import '../assets/css/staticElements.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';



/*--cows footer--*/

import mu1 from '../assets/cowsss/lower/3.webp';
import mu2 from '../assets/cowsss/lower/5.webp';
import mu3 from '../assets/cowsss/lower/6.webp';
import mu4 from '../assets/cowsss/lower/7.webp';
import mu5 from '../assets/cowsss/lower/4.webp';
import mu6 from '../assets/cowsss/lower/1.webp';
import social2 from '../assets/icons/phone.webp';
import social3 from '../assets/icons/insta.webp';


/*--Meets--*/

import dzieciWKole from '../assets/tour/lower/dzieciKoło.webp';
import karmienie from '../assets/tour/lower/grupaKarmienie.webp';
import grupaMala from '../assets/tour/lower/grupaMała.webp';
import WhiteSession1 from '../assets/tour/lower/sesjaBiała.webp';
import WhiteSession2 from '../assets/tour/lower/sesjaBiała2.webp';
import Pani1 from '../assets/tour/lower/sesjaPani1.webp';
import Pani2 from '../assets/tour/lower/sesjaPani2.webp';
import krowa from '../assets/tour/higher/krowa.webp';
import pozdrowienia from '../assets/tour/lower/pozdrowionka.webp'; 


/*--logo--*/
import logo from '../assets/img/logo.webp';


/*--higher--*/

/*--Meets--*/
import dzieciWKoleh from '../assets/tour/higher/dzieciKoło.webp';
import grupaMalah from '../assets/tour/higher/grupaMała.webp';
import WhiteSession1h from '../assets/tour/higher/sesjaBiała.webp';
import Pani1h from '../assets/tour/higher/sesjaPani1.webp';
import pozdrowieniah from '../assets/tour/higher/pozdrowionka.webp'; 

/*--cows footer--*/

import mu1h from '../assets/cowsss/higher/3.webp';
import mu2h from '../assets/cowsss/higher/5.webp';
import mu3h from '../assets/cowsss/higher/6.webp';
import mu4h from '../assets/cowsss/higher/7.webp';
import mu5h from '../assets/cowsss/higher/4.webp';
import mu6h from '../assets/cowsss/higher/1.webp';


/*========================================
        Functions!!!
=========================================*/

function Tours({Changing5}) {
    return (
        <>
        <article className='TourContainer'>
              <section className='TourSection'>
                {/*--Tour description--*/}
                <Row className='TourDescription'>
                    <h1>Poznaj nasze krowy Highland na żywo!</h1> 
                  {/*<img onLoad={Changing5} src={grupaDuza} alt="duza grupa" id="grupaDuza" />*/} 
                  <div className="tour-image-container" />
                    <div>           
                        <p>Marzysz o bliskim spotkaniu z majestatycznymi krowami Highland? Zapraszamy Cię na niezapomniane chwile w sercu natury! Podczas wizyty w naszym gospodarstwie możesz:</p>
                        <ul>
                            <li>Spacerować wśród krów na otwartej przestrzeni</li>
                            <li>Karmić i głaskać nasze przyjazne zwierzęta</li>
                            <li>Wziąć udział w kameralnej wycieczce z opiekunem</li>
                            <li>Zorganizować profesjonalną sesję zdjęciową w wyjątkowej scenerii</li>    
                        </ul> 
                        <p>Nasze krowy są przyzwyczajone do ludzi, łagodne i ciekawskie, dzięki czemu każde spotkanie jest bezpieczne i pełne radości.</p>
                        <h3>Idealna atrakcja dla rodzin, par, grup znajomych i miłośników natury!</h3>
                    </div>
                </Row>
                {/*--Tour gallery--*/}    
                <Row className='TourGallery'>
                    <Col lg={6} md={6} sm={12}>
                        <img onLoad={Changing5} src={Pani1} alt="sesja zdjeciowa" id="Pani1"/>
                        <img onLoad={Changing5} src={WhiteSession1} alt='sesja zdjeciowa' id="WhiteSession1"/> 
                        <img onLoad={Changing5} src={grupaMala} alt='mala grupa' id="grupaMala"/> 
                        <img onLoad={Changing5} src={WhiteSession2} alt='sesja zdjeciowa' id="WhiteSession2"/> 
                      </Col>
                    <Col lg={6} md={6} sm={12}>
                        <img onLoad={Changing5} src={dzieciWKole} alt='dzieci w kole' id="dzieciWKole"/> 
                        <img onLoad={Changing5} src={karmienie} alt='karmienie' id="karmienie"/> 
                        <img onLoad={Changing5} src={Pani2} alt='sejsa zdecjiowa' id="Pani2"/>  
                        <img onLoad={Changing5} src={krowa} alt='krówka' id="krowa"/>    
                    </Col>  
                </Row> 
                {/*--Zaproszenie--*/}
                <Row className='TourInvitation'>
                    <Col lg={6} md={6} sm={12} className='InvitationText'>
                        <div>
                            <h2>Przeżyj wyjątkową przygodę!</h2>
                            <hr />    
                            <h3>
                                Czekamy na Ciebie z otwartymi ramionami i szerokimi rogami!
                            </h3>    
                        </div>
                    </Col> 
                    <Col lg={6} md={6} sm={12}>
                        <img src={pozdrowienia} alt='pozdrowienia krowy' id="pozdrowienia"/>
                    </Col>    
                </Row>   
            </section>
        </article>
        </>
    );
}


/*========================================
        Functions!!!
=========================================*/

function LinkToContact() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/');
    navigate('/#Contact');
  };

  return (
    <button onClick={handleClick}>O nas</button>
  );
}

function LinkToProducts() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/');
    navigate('/#Products');
  };

  return (
    <button onClick={handleClick}>Produkty</button>
  );
}

/*========================================
        Header!!!
=========================================*/

function Header(){
  return (
    <>
    {/*====Header====*/}
    <header>
      <Row className='p-4'>
        {/*----Logo----*/}
        <Col xl={8} lg={7} md={6}>
          <div className='Logo'>
              <Link to="/" reloadDocument={true}>
                <Row>
                  <Col lg={1} md={2} xs={2} className='log'>
                    <img src={logo} alt='logo' />
                  </Col>
                  <Col  lg={10} md={9} xs={9} className='log textlog'>
                    Beskidzkie Stado
                  </Col>
                </Row>
              </Link>
          </div>
        </Col>
        {/*----Tabs----*/}
        <Col xl={4} lg={5} md={6} className='log'>
          <Row className='Tabs'>
            <Col lg={3} md={3} xs={3} className='Tcol'>
              <a href='#About' >
                <LinkToContact />
              </a>
            </Col>
            <Col lg={3} md={3} xs={3} className='Tcol'>
              <a href='#Products'>
                <LinkToProducts />
              </a>
            </Col>
            <Col lg={3} md={3} xs={3} className='Tcol'>
              <a href='#Contact'>
                <button>Kontakt</button>
              </a>
            </Col>
            <Col lg={3} md={3} xs={3} className='Tcol'>
                <Link to="/blog" reloadDocument = {true}>
                  <button>Blog</button>
                </Link>
            </Col>
          </Row>
        </Col>
      </Row>
      </header >
    </>
  );
}



/*========------------========*/
/*========------------========*/
/*------Footer------*/
/*========------------========*/
/*========------------========*/

function Footer({Changing5}) {
  return (
    <>
      <section className='footer'>
        <Row className='MiniGallery'>
          {/*-short gallery-*/}
          <Col lg={6} md={12} xs={12} className='mincol'>
            <section className='stadko'>
              {/*-logo-*/}
              <div className='FooterLogo'>
                <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                  <Row>
                    <Col lg={2} md={1} xs={2} className='logoFooter'>
                      <p>
                        <img src={logo} alt='logo' />
                      </p>
                    </Col>
                    <Col lg={10} md={11} xs={10} className='logoFooter'>
                      <h2>Beskidzkie Stado</h2>
                    </Col>
                  </Row>
                </a>
              </div>
              {/*-photos-*/}
              <div className='smallGallery'>
                <Row>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing5} src={mu6} alt="Cow" id="mu6"/>
                    </a>  
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing5} src={mu4} alt="Cow" id="mu4"/>
                    </a>
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing5} src={mu3} alt="Cow" id="mu3"/>
                    </a>
                  </Col>
                </Row>
                <Row className='tooff'>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing5} src={mu2} alt="Cow" id="mu2"/>
                    </a>
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing5} src={mu5} alt="Cow" id="mu5"/>
                    </a>
                  </Col>
                  <Col lg={4} md={4} xs={12} className='cowCol'>
                    <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                      <img onLoad={Changing5} src={mu1} alt="Cow" id="mu1"/>
                    </a>
                  </Col>
                </Row>
              </div>
            </section>
          </Col>
          {/*-Contact-*/}
          <Col lg={6} md={12} xs={12}  className='mincol'>
              <section className='contact' id='Contact'>
                <div>
                  <h2>Kontakt</h2>
                </div>
                <section className='links'>
                  {/*-phone-*/}
                  <Row className='package'>
                    <Col lg={2} md={12} xs={12} className='Colek'>
                      <a href='tel:+48 532 233 916'>
                        <img src={social2} alt="socialek" loading="lazy" />
                      </a>
                    </Col>
                    <Col lg={9} md={12} xs={12} className='Colek'>
                      <span>+48 532 233 916</span>
                    </Col>
                  </Row>
                  {/*-instagram-*/}
                  <Row className='package'>
                    <Col lg={2} md={12} xs={12} className='Colek'>
                      <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                        <img src={social3} alt="socialek" loading="lazy" />
                      </a>
                    </Col>
                    <Col lg={9} md={12} xs={12} className='Colek'>
                      <a href='https://www.instagram.com/beskidzkie_stado/' target="_blank" rel="noreferrer">
                        <span>Beskidzkie_stado</span>
                      </a>
                    </Col>
                  </Row>
                </section>
            </section>
          </Col>
        </Row>
        {/*-Copyright-*/}
        <Row>
          <Col lg={12} md={12} xs={12} className='copyright'>
            <div className='copya'>All rights reserved. Created by <a href="https://pixelpick.pl"> PixelPick</a></div>
          </Col>
        </Row>
      </section>
    </>
  );
}


function Tour() {

  const [loadedCount5, setLoadedCount5] = useState(null);

  const Changing5 = () => {
    setLoadedCount5(prev => {
      const NewCount5 = prev + 1;
      if (NewCount5 === 14) {
        setTimeout(() => {
          console.log("Iaam loading better quality photos now");
  
          const swap = (id, src) => {
            const el = document.getElementById(id);
            if (el) el.src = src;
            else console.warn(`${id} not found in DOM`);
          };

          swap("dzieciWKole", dzieciWKoleh);
          swap("grupaMala", grupaMalah);
          swap("WhiteSession1", WhiteSession1h);
          swap("Pani1", Pani1h);
          swap("pozdrowienia", pozdrowieniah);
          swap("mu1", mu1h);
          swap("mu2", mu2h);
          swap("mu3", mu3h);
          swap("mu4", mu4h);
          swap("mu5", mu5h);
          swap("mu6", mu6h);
  
        }, 2000);
        console.log(loadedCount5);
      }
      return NewCount5;
    });
  };
  

    return (
        <>
            <Header/>
            <Tours Changing5={Changing5}/>
            <Footer Changing5={Changing5}/>
        </>
    );
}

export default Tour;